import { render, staticRenderFns } from "./change-language.vue?vue&type=template&id=0ae9af86&scoped=true"
import script from "./change-language.vue?vue&type=script&lang=js"
export * from "./change-language.vue?vue&type=script&lang=js"
import style0 from "./change-language.vue?vue&type=style&index=0&id=0ae9af86&prod&lang=css"
import style1 from "./change-language.vue?vue&type=style&index=1&id=0ae9af86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae9af86",
  null
  
)

export default component.exports